/**
 * 🎮 USE GAMIFICATION HOOK — Hook para dados de gamificação do usuário
 */

import { useState, useEffect } from 'react';
import { GamificationService, type UserPoints, type LeaderboardEntry } from '../services/gamificationService';
import { useAuth } from '../context/AuthContext';
import { useWorkspace } from '../contexts/WorkspaceContext';

export const useGamification = () => {
  const { user } = useAuth();
  const { workspace } = useWorkspace();
  const [userPoints, setUserPoints] = useState<UserPoints | null>(null);
  const [rank, setRank] = useState<number>(0);
  const [leaderboard, setLeaderboard] = useState<LeaderboardEntry[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadGamificationData();
  }, [user?.id, workspace?.organizationId]);

  const loadGamificationData = async () => {
    if (!user?.id || !workspace?.organizationId) {
      setLoading(false);
      return;
    }

    // 🔧 Desabilitar gamificação para organização fake de desenvolvimento
    if (workspace.organizationId === 'dev-org') {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      // Carregar pontos do usuário
      const points = await GamificationService.getUserPoints(
        user.id,
        workspace.organizationId
      );
      setUserPoints(points);

      // Carregar rank do usuário
      if (points) {
        const userRank = await GamificationService.getUserRank(
          user.id,
          workspace.organizationId
        );
        setRank(userRank);
      }

      // Leaderboard desabilitado: a view gamification_leaderboard faz JOIN em
      // auth.users que é bloqueado por RLS (403/42501). Requer migration DB.
      // const top10 = await GamificationService.getLeaderboard(workspace.organizationId, 10);
      // setLeaderboard(top10);

    } catch (err) {
      console.error('Erro ao carregar gamificação:', err);
      setError('Erro ao carregar dados de gamificação');
    } finally {
      setLoading(false);
    }
  };

  const refresh = () => {
    loadGamificationData();
  };

  return {
    userPoints,
    rank,
    leaderboard,
    loading,
    error,
    refresh,
  };
};

export default useGamification;
